import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatOptionModule } from '@angular/material/core'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'

import { TranslateModule } from '@ngx-translate/core'

import { EPerformanceSummaryFlag } from '~/core/models'

@Component({
  selector: 'app-performance-summary-flag-selector',
  templateUrl: './performance-summary-flag-selector.component.html',
  styleUrl: './performance-summary-flag-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, TranslateModule, MatSelectModule, MatOptionModule, MatFormFieldModule],
})
export class PerformanceSummaryFlagSelectorComponent {
  readonly summaryFlag = input<EPerformanceSummaryFlag>(EPerformanceSummaryFlag.SUMMARY_COLUMN)
  readonly summaryFlagList = input<
    {
      value: EPerformanceSummaryFlag
      i18nTitle: string
    }[]
  >([])

  readonly changeSummaryFlag = output<EPerformanceSummaryFlag>()
}
